import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { IWizardOptions } from '../../../models';

@Component({
    selector: 'wizard-location',
    templateUrl: './location.component.html',
    styleUrls: ['../../form-styles.scss']
})
export class LocationComponent extends BaseComponent implements OnInit {
    public location = '';
    private defaultsSubscription: Subscription;

    constructor(public wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.subscribeToMeetingDefaultsUpdates();
        this.restoreLocationIfExists();
    }

    ngOnDestroy() {
        this.defaultsSubscription.unsubscribe();
    }

    subscribeToMeetingDefaultsUpdates() {
        this.defaultsSubscription = this.wizardService.onNewDefaultOptions$.subscribe((defaults: IWizardOptions) => {
            if (defaults) {
                this.setNewLocation(defaults.locations);
            }
        });
    }

    restoreLocationIfExists() {
        if (this.wizardService.options.locations && this.wizardService.options.locations[0]) {
            const location = this.wizardService.options.locations[0].name;
            this.updateLocation(location);
        }
    }

    setNewLocation(locations: { name: string }[]) {
        if (this.wizardService.isCustomLocation) {
            return;
        }
        const newLocation = locations[0] ? locations[0].name : '';
        this.updateLocation(newLocation);
    }

    updateLocation(location: string) {
        this.location = location;
        if (!!location) {
            this.wizardService.updateOptions({
                locations: [
                    {
                        name: location
                    }
                ]
            });
        } else {
            this.wizardService.updateOptions({ locations: [] });
        }
    }

    handleKeyup() {
        this.wizardService.isCustomLocation = this.location ? true : false;
    }
}
